<template>
  <section class="horizontal-product-list">
    <carousel :title="props.title" navigator :data="slicedList" swiper-container-class="mt-2 mb-3 md:mt-4 md:mb-0">
      <template #default="{ item }">
        <product-card class="w-297px" time-slot-class="size-13" :product-id="item" :max-slots-count="MAX_SLOTS_COUNT" />
      </template>
    </carousel>
  </section>
</template>

<script lang="ts" setup>
import Carousel from '@/components/common/carousel.vue'
import ProductCard from '@/components/product/product-card.vue'

interface Props {
  title: string
  list: number[]
}

const MAX_DISPLAY_COUNT = 10
// https://www.figma.com/design/H8XF891oLkmXTTsE1fS0t5/eatigo-WEB?node-id=3794-58160&m=dev
const MAX_SLOTS_COUNT = 4

const props = defineProps<Props>()

const slicedList = computed(() => props.list.slice(0, MAX_DISPLAY_COUNT))
</script>
